<script setup>
import {RMDropdown} from 'redmine-ui-kit';

import ThemeButton from '@/components/ThemeButton.vue';
import SettingsIcon from '@/assets/images/icons/settings.svg';

const MAX_THEME_COLORS_LENGTH = 8;

defineProps({
    themeTitles: {
        type: Array,
        required: true,
    },
    themes: {
        type: Object,
        required: true,
    },
    selectedThemeTitle: {
        type: String,
        default: () => '',
    },
});

const emit = defineEmits(['change-theme']);
</script>

<template>
    <RMDropdown>
        <template #trigger>
            <button
                type="button"
                class="theme-changer-trigger"
            >
                <SettingsIcon />
            </button>
        </template>
        <template #content>
            <div class="theme-changer-content custom-scroll">
                <ThemeButton
                    v-for="themeTitle in themeTitles"
                    :key="themeTitle"
                    :theme-title="themeTitle"
                    :active="selectedThemeTitle === themeTitle"
                    :style="{backgroundColor: themes[themeTitle].backgroundColor}"
                    :colors="themes[themeTitle].color.slice(0, MAX_THEME_COLORS_LENGTH)"
                    @change-theme="emit('change-theme', themeTitle)"
                />
            </div>
        </template>
    </RMDropdown>
</template>

<style lang="scss">
:root {
    --rm-dropdown-background-color: #ffffff;
}

.theme-changer-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-height: 300px;
    padding: 16px 12px;
}

.theme-changer-trigger {
    border: none;
    background-color: transparent;
    cursor: pointer;
}
</style>
